import { AllSectorValues } from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getAllSectorValues = (): Promise<AllSectorValues> => {
  return request({
    url: '/service/cbientityservice/GetAllSectorValues',
  }).then((r): AllSectorValues => r.body);
};
